import Select from "@storeblocks/select";
import styled from "styled-components";

export const StyledSelectDiv = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 32px;
`;

export const StyledSpinnerDiv = styled.div`
  align-items: end;
  display: flex;
  margin-left: 16px;
  padding-bottom: 8px;
`;

export const StyledStoreblocksSelect = styled(Select)`
  max-width: 100%;

  & > div {
    max-width: 100%;
  }
`;
